export enum CodigoTributoDeclaracaoMensal {
    IRPJ = 1001,
    CSLL = 1002,
    COFINS = 1004,
    PIS = 1005,
    INSSCPP = 1006,
    ICMS = 1007,
    IPI = 1008,
    ISS = 1010
}